class ResizeManager {
  private subscribers: Map<string, (isSmall: boolean) => void> = new Map()
  private mediaQuery: MediaQueryList

  constructor(breakpoint: number = 1024) {
    this.mediaQuery = window.matchMedia(`(min-width: ${breakpoint}px)`)
    this.mediaQuery.addEventListener('change', () => this.notifyAll())
  }

  subscribe(id: string, callback: (isSmall: boolean) => void): () => void {
    this.subscribers.set(id, callback)
    callback(!this.mediaQuery.matches)

    return () => this.subscribers.delete(id)
  }

  private notifyAll(): void {
    const isSmall = !this.mediaQuery.matches
    this.subscribers.forEach((callback) => callback(isSmall))
  }

  isSmall(): boolean {
    return !this.mediaQuery.matches
  }

  destroy(): void {
    this.subscribers.clear()
    this.mediaQuery.removeEventListener('change', () => this.notifyAll())
  }
}

export const resizeManager = new ResizeManager(1024)
